var React = require('react');

function AngleLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M223.83 352.44a24 24 0 0 1 0 33.86L201.32 409l-.18.18a23.76 23.76 0 0 1-33.6-.18l-96.15-96.5 56.47-56.5z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M167.81 102.87l-.17.18L32.11 239a24 24 0 0 0-.17 33.93l.06.07 39.39 39.51L224 159.66a23.92 23.92 0 0 0 0-33.84l-22.54-22.74a23.77 23.77 0 0 0-33.62-.23z","className":"fa-primary","key":2})]);
}

AngleLeft.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = AngleLeft;

AngleLeft.default = AngleLeft;
